module.exports = __webpack_public_path__ + "static/media/8co.16b72ea0.png";